import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function PaperBulkIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.4"
        d="M18.8088 9.021C18.3573 9.021 17.7592 9.011 17.0146 9.011C15.1987 9.011 13.7055 7.508 13.7055 5.675V2.459C13.7055 2.206 13.5036 2 13.253 2H7.96363C5.49517 2 3.5 4.026 3.5 6.509V17.284C3.5 19.889 5.59022 22 8.16958 22H16.0463C18.5058 22 20.5 19.987 20.5 17.502V9.471C20.5 9.217 20.299 9.012 20.0475 9.013C19.6247 9.016 19.1177 9.021 18.8088 9.021Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M16.0827 2.56725C15.7837 2.25625 15.2617 2.47025 15.2617 2.90125V5.53825C15.2617 6.64425 16.1727 7.55425 17.2787 7.55425C17.9757 7.56225 18.9437 7.56425 19.7657 7.56225C20.1867 7.56125 20.4007 7.05825 20.1087 6.75425C19.0537 5.65725 17.1647 3.69125 16.0827 2.56725Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.97447 11.3876H12.3595C12.7705 11.3876 13.1045 11.0546 13.1045 10.6436C13.1045 10.2326 12.7705 9.89856 12.3595 9.89856H8.97447C8.56347 9.89856 8.23047 10.2326 8.23047 10.6436C8.23047 11.0546 8.56347 11.3876 8.97447 11.3876ZM8.97457 16.3818H14.4186C14.8296 16.3818 15.1636 16.0488 15.1636 15.6378C15.1636 15.2268 14.8296 14.8928 14.4186 14.8928H8.97457C8.56357 14.8928 8.23057 15.2268 8.23057 15.6378C8.23057 16.0488 8.56357 16.3818 8.97457 16.3818Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
